import { Link } from 'react-router-dom';
import { TrendingUp, ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const AGBPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto p-6">
        <Link to="/" className="inline-flex items-center gap-2 mb-8 text-primary hover:underline">
          <ArrowLeft className="h-4 w-4" />
          Zurück zur Startseite
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <TrendingUp className="h-10 w-10 text-primary" />
          <h1 className="text-4xl font-heading font-bold">Allgemeine Geschäftsbedingungen (AGB)</h1>
        </div>

        <Card className="glass">
          <CardContent className="pt-6 space-y-8">
            
            {/* § 1 Geltungsbereich */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 1 Geltungsbereich</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>1.1</strong> Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für sämtliche Verträge zwischen dem Betreiber der Plattform TradeJourn.ai (nachfolgend „Anbieter") und den Nutzern der Trading-Journal-Webseite sowie der zugehörigen Dienste (nachfolgend „Nutzer").
                </p>
                <p>
                  <strong>1.2</strong> Die AGB gelten für alle angebotenen Leistungen, insbesondere:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Nutzung der Trading-Journal-Funktionen</li>
                  <li>Nutzung von Analyse-, Auswertungs- und KI-gestützten Funktionen</li>
                  <li>Nutzung kostenpflichtiger Abonnements (Basic, Pro, Premium)</li>
                </ul>
                <p>
                  <strong>1.3</strong> Abweichende, entgegenstehende oder ergänzende Bedingungen des Nutzers werden nicht Vertragsbestandteil, es sei denn, ihrer Geltung wird ausdrücklich schriftlich zugestimmt.
                </p>
              </div>
            </section>

            {/* § 2 Leistungsbeschreibung */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 2 Leistungsbeschreibung</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>2.1</strong> TradeJourn.ai stellt dem Nutzer eine webbasierte Plattform zur Verfügung, die der Dokumentation, Analyse und Auswertung von Trading-Aktivitäten dient.
                </p>
                <p>
                  <strong>2.2</strong> Die Plattform bietet unter anderem:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Manuelle und automatisierte Erfassung von Trades</li>
                  <li>Import von Trades (z. B. CSV-Import, Screenshot-Import)</li>
                  <li>Statistische Auswertungen und Performance-Analysen</li>
                  <li>KI-gestützte Auswertungen, Hinweise und Mentor-Funktionen</li>
                </ul>
                <p className="mt-4 p-3 bg-amber-500/10 border border-amber-500/30 rounded-lg">
                  <strong>2.3 Wichtiger Hinweis:</strong> Die bereitgestellten Analysen, Hinweise und KI-Auswertungen stellen <strong>keine Anlageberatung</strong>, keine Finanzberatung und keine Empfehlung zum Kauf oder Verkauf von Finanzinstrumenten dar.
                </p>
              </div>
            </section>

            {/* § 3 Abonnement-Modelle */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 3 Abonnement-Modelle</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>3.1</strong> Die Nutzung der Plattform erfolgt je nach gewähltem Tarif kostenlos oder kostenpflichtig im Rahmen eines Abonnements.
                </p>
                <p>
                  <strong>3.2</strong> Der Anbieter bietet insbesondere folgende Abonnement-Modelle an:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li><strong>Basic</strong> – Grundlegende Journal-Funktionen</li>
                  <li><strong>Pro</strong> – Erweiterte Funktionen inkl. Screenshot-Import</li>
                  <li><strong>Premium</strong> – Vollzugriff inkl. KI Trading-Mentor</li>
                </ul>
                <p>
                  <strong>3.3</strong> Der konkrete Leistungsumfang der einzelnen Abonnements ergibt sich aus der jeweils aktuellen Leistungsbeschreibung auf der Webseite des Anbieters.
                </p>
                <p>
                  <strong>3.4</strong> Der Anbieter behält sich vor, Leistungsinhalte der Abonnements anzupassen, weiterzuentwickeln oder zu ändern, sofern dadurch keine wesentlichen Vertragspflichten beeinträchtigt werden.
                </p>
              </div>
            </section>

            {/* § 4 Vertragsschluss */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 4 Vertragsschluss</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>4.1</strong> Der Vertrag kommt durch Abschluss des Bestell- bzw. Buchungsvorgangs über die Plattform oder über einen externen Zahlungsanbieter zustande.
                </p>
                <p>
                  <strong>4.2</strong> Die Zahlungsabwicklung kann über Drittanbieter (z. B. CopeCart) erfolgen. In diesem Fall gelten ergänzend die Geschäftsbedingungen des jeweiligen Zahlungsanbieters.
                </p>
                <p>
                  <strong>4.3</strong> Mit Abschluss des Abonnements erklärt der Nutzer, dass er mindestens 18 Jahre alt ist und voll geschäftsfähig handelt.
                </p>
              </div>
            </section>

            {/* § 5 Preise und Zahlungsbedingungen */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 5 Preise und Zahlungsbedingungen</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>5.1</strong> Die angegebenen Preise verstehen sich in der jeweils ausgewiesenen Währung und inklusive der gesetzlichen Umsatzsteuer, sofern anwendbar.
                </p>
                <p>
                  <strong>5.2</strong> Die Abrechnung der Abonnements erfolgt periodisch (monatlich oder jährlich, je nach Auswahl).
                </p>
                <p>
                  <strong>5.3</strong> Der Abonnementbetrag wird im Voraus fällig.
                </p>
                <p>
                  <strong>5.4</strong> Bei Zahlungsverzug ist der Anbieter berechtigt, den Zugang zu kostenpflichtigen Funktionen vorübergehend zu sperren.
                </p>
              </div>
            </section>

            {/* § 6 Laufzeit und Kündigung */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 6 Laufzeit und Kündigung</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>6.1</strong> Abonnements werden für die jeweils vereinbarte Laufzeit abgeschlossen.
                </p>
                <p>
                  <strong>6.2</strong> Sofern nicht anders angegeben, verlängert sich das Abonnement automatisch um die jeweils gewählte Laufzeit, wenn es nicht vor Ablauf gekündigt wird.
                </p>
                <p>
                  <strong>6.3</strong> Die Kündigung kann durch den Nutzer über das Benutzerkonto oder über den jeweiligen Zahlungsanbieter erfolgen.
                </p>
                <p>
                  <strong>6.4</strong> Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
                </p>
              </div>
            </section>

            {/* § 7 Widerrufsrecht */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 7 Widerrufsrecht (Verbraucher)</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>7.1</strong> Verbrauchern steht grundsätzlich ein gesetzliches Widerrufsrecht zu.
                </p>
                <p>
                  <strong>7.2</strong> Das Widerrufsrecht kann vorzeitig erlöschen, wenn der Anbieter mit der Ausführung der digitalen Leistung begonnen hat und der Nutzer ausdrücklich zugestimmt hat, dass:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>der Anbieter vor Ablauf der Widerrufsfrist mit der Ausführung beginnt, und</li>
                  <li>der Nutzer Kenntnis vom Erlöschen des Widerrufsrechts hat.</li>
                </ul>
              </div>
            </section>

            {/* § 8 Nutzungspflichten */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 8 Nutzungspflichten des Nutzers</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>8.1</strong> Der Nutzer verpflichtet sich, die Plattform ausschließlich im Rahmen der geltenden Gesetze zu nutzen.
                </p>
                <p>
                  <strong>8.2</strong> Der Nutzer ist verpflichtet, seine Zugangsdaten geheim zu halten und nicht an Dritte weiterzugeben.
                </p>
                <p>
                  <strong>8.3</strong> Es ist untersagt:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>die Plattform missbräuchlich zu nutzen</li>
                  <li>Inhalte zu manipulieren oder zu verfälschen</li>
                  <li>automatisierte Zugriffe ohne Zustimmung des Anbieters vorzunehmen</li>
                </ul>
              </div>
            </section>

            {/* § 9 Haftungsausschluss für Trading-Inhalte */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 9 Haftungsausschluss für Trading-Inhalte</h2>
              <div className="space-y-3 text-muted-foreground p-4 bg-rose-500/10 border border-rose-500/30 rounded-lg">
                <p>
                  <strong>9.1</strong> Die Nutzung der Plattform erfolgt auf eigenes Risiko des Nutzers.
                </p>
                <p>
                  <strong>9.2</strong> Der Anbieter übernimmt keine Haftung für finanzielle Verluste, die aus Trading-Entscheidungen des Nutzers resultieren.
                </p>
                <p>
                  <strong>9.3</strong> Insbesondere wird keine Haftung übernommen für:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Marktbewegungen</li>
                  <li>Kursverluste</li>
                  <li>Fehlentscheidungen aufgrund von Analysen oder KI-Hinweisen</li>
                </ul>
              </div>
            </section>

            {/* § 10 KI-Funktionen */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 10 KI-Funktionen</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>10.1</strong> KI-gestützte Funktionen basieren auf algorithmischen Modellen und statistischen Auswertungen.
                </p>
                <p>
                  <strong>10.2</strong> Die KI kann fehlerhafte, unvollständige oder unzutreffende Ergebnisse liefern.
                </p>
                <p className="p-3 bg-emerald-500/10 border border-emerald-500/30 rounded-lg">
                  <strong>10.3</strong> KI-Ausgaben dienen ausschließlich der Unterstützung, Analyse und Reflexion und ersetzen keine menschliche Bewertung oder professionelle Beratung.
                </p>
              </div>
            </section>

            {/* § 11 Verfügbarkeit */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 11 Verfügbarkeit</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>11.1</strong> Der Anbieter bemüht sich um eine möglichst unterbrechungsfreie Verfügbarkeit der Plattform.
                </p>
                <p>
                  <strong>11.2</strong> Wartungsarbeiten, technische Störungen oder externe Einflüsse können zu temporären Einschränkungen führen.
                </p>
                <p>
                  <strong>11.3</strong> Ein Anspruch auf eine jederzeitige, fehlerfreie Verfügbarkeit besteht nicht.
                </p>
              </div>
            </section>

            {/* § 12 Datenschutz */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 12 Datenschutz</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>12.1</strong> Die Verarbeitung personenbezogener Daten erfolgt gemäß der geltenden Datenschutzgesetze (DSGVO).
                </p>
                <p>
                  <strong>12.2</strong> Nähere Informationen ergeben sich aus der <Link to="/datenschutz" className="text-primary hover:underline">Datenschutzerklärung</Link> des Anbieters.
                </p>
              </div>
            </section>

            {/* § 13 Geistiges Eigentum */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 13 Geistiges Eigentum</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>13.1</strong> Sämtliche Inhalte, Software-Komponenten, Designs und Texte der Plattform unterliegen dem Urheberrecht.
                </p>
                <p>
                  <strong>13.2</strong> Eine Vervielfältigung, Verbreitung oder öffentliche Zugänglichmachung ohne ausdrückliche Zustimmung ist untersagt.
                </p>
              </div>
            </section>

            {/* § 14 Sperrung von Nutzern */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 14 Sperrung von Nutzern</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>14.1</strong> Der Anbieter ist berechtigt, Nutzerkonten bei Verstößen gegen diese AGB vorübergehend oder dauerhaft zu sperren.
                </p>
                <p>
                  <strong>14.2</strong> In diesem Fall besteht kein Anspruch auf Rückerstattung bereits gezahlter Entgelte, sofern der Nutzer den Verstoß zu vertreten hat.
                </p>
              </div>
            </section>

            {/* § 15 Änderungen der AGB */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 15 Änderungen der AGB</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>15.1</strong> Der Anbieter behält sich vor, diese AGB zu ändern.
                </p>
                <p>
                  <strong>15.2</strong> Änderungen werden dem Nutzer rechtzeitig in geeigneter Form mitgeteilt.
                </p>
                <p>
                  <strong>15.3</strong> Widerspricht der Nutzer nicht innerhalb der mitgeteilten Frist, gelten die Änderungen als akzeptiert.
                </p>
              </div>
            </section>

            {/* § 16 Schlussbestimmungen */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-primary">§ 16 Schlussbestimmungen</h2>
              <div className="space-y-3 text-muted-foreground">
                <p>
                  <strong>16.1</strong> Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts, sofern keine zwingenden Verbraucherschutzvorschriften entgegenstehen.
                </p>
                <p>
                  <strong>16.2</strong> Gerichtsstand ist, soweit zulässig, der Sitz des Anbieters.
                </p>
                <p>
                  <strong>16.3</strong> Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
                </p>
              </div>
            </section>

            {/* Stand */}
            <div className="pt-6 border-t border-zinc-700">
              <p className="text-sm text-muted-foreground">
                Stand: Januar 2026
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AGBPage;
